var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},[_c('transition',{attrs:{"name":"fadeInDown"}},[(_vm.password && _vm.password.length)?_c('span',[_vm._v(" "+_vm._s(_vm.strength)+" ")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }